import { connect } from 'react-redux';
import { PageCardDropdownStyle } from '../styles';
import { changeTab_action, createDraft_action, getDrafts_action, getTotalItemsCount_action, markAsFavorite_action, pinToCategory_action, setSelectedPageOrDraft, toggleContentPermissionModal_action, toggleDeleteContentModal_action, toggleMoveToCategoryModal_action, toggleSettingsModal_action, toggleShareModal_action } from 'store/actions';
import { ReactComponent as EditIcon } from 'assets/images/icons/edit_2.svg'
import { ReactComponent as PageIcon } from 'assets/images/icons/page.svg'
import { ReactComponent as DraftPageIcon } from 'assets/images/icons/draft_page.svg'
import { ReactComponent as PushPinIcon } from 'assets/images/icons/push_pin.svg'
import { ReactComponent as SharedPageIcon } from 'assets/images/icons/shared_page.svg'
import { ReactComponent as PinSvg } from 'assets/images/icons/pin_line.svg'
import { ReactComponent as UnpinSvg } from 'assets/images/icons/unpin_line.svg'
import { ReactComponent as DuplicateIcon } from 'assets/images/icons/duplicate_draft.svg'
import { ReactComponent as ExternalIcon } from 'assets/images/icons/External.svg'
import { ReactComponent as CopyLinkIcon } from 'assets/images/icons/copy_link.svg'
import { ReactComponent as MoveIcon } from 'assets/images/icons/move_to_category_icon.svg'
import { ReactComponent as UnpublishIcon } from 'assets/images/icons/unpublish.svg'
import { ReactComponent as DeleteIcon } from 'assets/images/icons/trash_2.svg'
import { ReactComponent as CollabrationIcon } from 'assets/images/icons/collabration.svg'
import { ReactComponent as PinToCategoryIcon } from 'assets/images/icons/pin_to_category.svg'
import { ReactComponent as UnpinToCategoryIcon } from 'assets/images/icons/unpin_from_category.svg'
import { checkUser_for_admin_or_owner, checkUser_for_admin_or_owner_or_editor, consoleLog, copyLink, generateSlug, handleApiError, uuidExtract } from 'utils/helpers';
import { duplicatePage_api, getContentByUUID_api } from 'store/apis';
import { history } from 'store/store';
import {toast} from 'react-toastify';

const PageCardDropdown = (props) => {
  const { selectedPage: page } = props;


  const onEditPage = async (e, uuid) => {
    e.preventDefault()
    try {
      // Get latest published page
      const _uuid = uuidExtract(uuid)
      let _page = await getContentByUUID_api(_uuid)
      if (_page) {
        try {
          _page = { ..._page, category: _page.category || {} }
          const draft = await props.createDraft(_page, true)
          history.push(`/pages/drafts/edit/${generateSlug(draft)}`)
          props.getTotalItemsCount()
          props.getDrafts()
        } catch (error) {
          consoleLog(error)
        }
      }
    } catch (error) {
      handleApiError(error)
    }
  }

 const openShareModal = (item) => {
    if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed) {
      props.toggleSettingsModal(true)
      props.changeTab('billing')
      history.push('/')
    } else {
      props.toggleShareModal(true, item)
    }
  }

  return (
    <PageCardDropdownStyle>
      {page.is_accessible && (
        <>
          {!!!page.is_draft && checkUser_for_admin_or_owner_or_editor(page, props.user) && (
            <div className='dropdownChild' onClick={(e) => onEditPage(e, page.uuid)}>
              <EditIcon />
              Edit
            </div>
          )}
          <div
            className='dropdownChild'
            onClick={async () => {
              if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                props.toggleSettingsModal(true)
                props.changeTab('billing')
                history.push('/')
              } else {
                const result = await duplicatePage_api(page.id)
                props.getTotalItemsCount()
                history.push(`/pages/drafts/edit/${generateSlug(result)}`)
                props.getDrafts()
              }
            }}>
            <DuplicateIcon />
            {page.is_draft ? 'Duplicate' : 'Duplicate as Draft'}
          </div>
        </>
      )}

      {!!!page.is_draft && (props.user.membership.user_type === 'admin' || props.who_can_share === 'members') && (
        <div className='dropdownChild' onClick={() => openShareModal(page)}>
          <ExternalIcon />
          Share Externally
        </div>
      )}
      <div
        className='dropdownChild'
        onClick={() => {
          copyLink(page)
          toast.success('Link copied to clipboard!')
        }}>
        <CopyLinkIcon />
        Copy Link
      </div>
      {props.showMovetocategory && checkUser_for_admin_or_owner_or_editor(page, props.user) && (
        <div className='dropdownChild' onClick={() => props.toggleMoveToCategoryModal(true, { uuid: page.uuid })}>
          <MoveIcon />
          Move to Category
        </div>
      )}
      {!page.is_draft && (
        <div className='dropdownChild' onClick={() => props.markAsFavorite(page)}>
          {page.is_favorite ? (
            <>
              <UnpinSvg />
              <span>Unpin This File (For you)</span>
            </>
          ) : (
            <>
              <PinSvg />
              <span>Pin This File (For you)</span>
            </>
          )}
        </div>
      )}
      {props.user.membership.user_type === 'admin' && !!!page.is_draft && page.category_id && (
        <div className='dropdownChild' onClick={() => props.pinToCategory(page)}>
          {page.pinned_to_category ? (
            <>
              <UnpinToCategoryIcon />
              <span>Unpin to Category</span>
            </>
          ) : (
            <>
              <PinToCategoryIcon />
              <span>Pin to Category</span>
            </>
          )}
        </div>
      )}
      {checkUser_for_admin_or_owner(page, props.user) && (
        <>
          {page.is_draft && (
            <div className='dropdownChild' onClick={() => props.toggleContentPermissionModal(true, page)}>
              <CollabrationIcon />
              Collaborators
            </div>
          )}
          {/* <div tag='span' className='divider'>
            {' '} */}
          {/* </div> */}

          <div className='dropdownChild' id="delete" onClick={() => props.toggleDeleteContentModal(true, { ...page }, true)}>
            {page.is_draft ? (
              <>
                <DeleteIcon height={24} width={24} />
                Delete
              </>
            ) : (
              <>
                <UnpublishIcon />
                Unpublish
              </>
            )}
          </div>
        </>
      )}
    </PageCardDropdownStyle>
  )
}

const mapStateToProps = state => ({
  selectedPage: state.app.currentPageDropdown,

  user: state.auth.user,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  free_items_limit: state.company.company.free_items_limit,
  total_items_count: state.app.total_items_count,
  loading_category_id: state.contents.loading_category_id,
  who_can_share: state.company.company.who_can_share,
  selectedPageOrDraft: state.contents.selectedPageOrDraft,
})

const mapDispatchToProps = dispatch => ({
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  markAsFavorite: (content) => dispatch(markAsFavorite_action(content)),
  pinToCategory: (content) => dispatch(pinToCategory_action(content)),
  getTotalItemsCount: () => dispatch(getTotalItemsCount_action()),
  toggleDeleteContentModal: (status, item, redirectToHome) => dispatch(toggleDeleteContentModal_action(status, item, redirectToHome)),
  toggleMoveToCategoryModal: (showMoveToCategoryModal, item) => dispatch(toggleMoveToCategoryModal_action(showMoveToCategoryModal, item)),
  toggleContentPermissionModal: (status, item) => dispatch(toggleContentPermissionModal_action(status, item)),
  getDrafts: () => new Promise((resolve, reject) => dispatch(getDrafts_action(resolve, reject))),
  toggleShareModal: (status, value) => dispatch(toggleShareModal_action(status, value)),
  createDraft: (data, isEditing) => new Promise((resolve, reject) => dispatch(createDraft_action(data, resolve, reject, isEditing))),
  setSelectedPageOrDraft: (page) => dispatch(setSelectedPageOrDraft(page)),
})
export default connect(mapStateToProps, mapDispatchToProps)(PageCardDropdown)